module.exports = __webpack_public_path__ + "static/media/contact.13d884db.png";